import { Transform } from "class-transformer";
import { FrontendFieldType } from "src/modules/sm-base/models/frontend-field-type.enum";
import { Utils } from "src/modules/utils/shared/utils";

export class GenDocField {
    id = 0;
    fieldId = "";
    value = "";
    fullObject: string;

    getValue(type: FrontendFieldType): any {
        try {
            let result = Utils.fromJson(this.value);
            if (type == FrontendFieldType.datePicker && result != null) {
                result = new Date(result);
                if (!Utils.dateValid(result)) {
                    result = null;
                }
            }
            return result;
        }
        catch (error) {
            console.log("Der Wert '" + this.value + "' kann nicht interpretiert werden. " + error.message);
            return null;
        }
    }

    getFullObject(): any {
        return Utils.fromJson(this.fullObject);
    }

}